import React, { Component } from 'react';
import { TreeView } from 'devextreme-react';
import "./navigation.css";
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { Glyphicon, Nav, Navbar, NavDropdown, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import NavigationItem from './navigationItem.jsx';

export default class Navigation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            products: [],
            redirect: false,
            redirectPath: '\summary',
            selectedItem: null
        };

        var tokenKey = 'accessToken';
        var token = sessionStorage.getItem(tokenKey);
        var login = JSON.parse(atob(token.split(".")[1])).ManagerLogin;
        var checkAdmin = login !== "" && login !== undefined && login !== null;

        fetch('api/main/navigation', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            }
        })
            .then(response => response.json())
            .then(data => {
                data[0].items = data[0].items.filter(item => {
                    if (item.text.includes('ПИФ')) return false
                    return true
                })
                this.setState({
                    products: data
                });
            });

        this.selectItem = this.selectItem.bind(this);
    }

    render() {

        if (this.state.redirect) {
            var path = this.state.redirectPath;
            var item = this.state.selectedItem;

            return (
                <div>
                    <Redirect push to={{
                        pathname: path,
                        state: {
                            objectId: item.objectId,
                            type: item.type,
                            product: item.product
                        }
                    }} />
                    <TreeView id={'simple-treeview'} className="navigationTree"
                        items={this.state.products}
                        width={300}
                        itemRender={NavigationItem}
                        onItemClick={this.selectItem}
                    />
                </div>
            );
        }

        return (
            <TreeView id={'simple-treeview'} className="navigationTree"
                items={this.state.products}
                width={300}
                itemRender={NavigationItem}
                onItemClick={this.selectItem}
            />
        );
    }

    selectItem(e) {
        var tokenKey = 'accessToken';
        var token = sessionStorage.getItem(tokenKey);
        var login = JSON.parse(atob(token.split(".")[1])).ManagerLogin;
        var checkAdmin = login !== "" && login !== undefined && login !== null;
        var icon = "navigationIcon";
        var path = '/position';

        if (e.itemData.type == "summary") {            
            path = '/summary';
        }

        if (e.itemData.type == "reports") {            
            path = '/reports';
        }

        if (e.itemData.type == "reportsManagement") {            
            path = '/reportsManagement';
        }

        if (e.itemData.type == "analytics") {            
            path = '/analytics';
        }

        if (e.itemData.type == "analyticsManagement") {            
            path = '/analyticsManagement';
        }        

        if (e.itemData.type == "portfolio") {
            icon = icon + " dx-icon-pin";
            path = '/position';
        }

        if (e.itemData.type == "fund" && checkAdmin) {
            icon = icon + " dx-icon-pin";
            path = '/fundPosition';
        }

        if (e.itemData.type == "fund" && !checkAdmin) {
            icon = icon + " dx-icon-pin";
            return
        }

        if (e.itemData.type == "users") {            
            path = '/users';
        }

        if (e.itemData.type == "settings") {
            path = '/settings';
        }

        if (e.itemData.type == "data") {
            path = '/data';
        }

        if (e.itemData.type == "bannerSwitch") {
            path = '/bannerSwitch';
        }

        this.setState({ redirect: true, redirectPath: path, selectedItem: e.itemData });
        //this.context.router.push('/analytics');

        //PropTypes.pushState(null, '/analytics');

        //window.history.pushState({}, null, path);
        //window.location.reload();
    }
}



// WEBPACK FOOTER //
// ./App/containers/navigation/navigation.jsx